import { Modal } from "antd";
import React from "react";

const VideoPreviewModal = ({
  visible,
  videoSrc,
  onClose,
  zIndex,
  getContainer,
}) => {
  return (
    <Modal
      visible={visible}
      footer={null}
      onCancel={onClose}
      width={800}
      centered
      destroyOnClose
      title="Video Preview"
      bodyStyle={{ padding: 0, backgroundColor: "#000" }}
      zIndex={zIndex}
      getContainer={getContainer}
    >
      {videoSrc && (
        <video
          controls
          autoPlay
          style={{ width: "100%", maxHeight: "80vh", display: "block" }}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </Modal>
  );
};

export default VideoPreviewModal;
